import React from 'react';

const Navbar = () => (
  <div className='flex mb-[100px]'>
<a href="/" >
  <img src={`https://i.pinimg.com/550x/79/4d/ef/794def9f95dbb4bceda06e75b095d5e4.jpg`} className='h-[260px] p-4 cursor-pointer' alt="logo" />
</a>
<div className='p-4 flex'>
</div>
</div>
);

export default Navbar;
